import { Component, OnInit, Injector } from '@angular/core';
import { IThirdNavCollapsibleElement } from 'src/app/common-page-components/third-nav-tab-component/third-nav-tab-component.component';
import { MembersRouterInterceptorService } from '../services/members-router-interceptor.service';
import { Router, ActivationEnd, NavigationStart, NavigationEnd } from '@angular/router';
import { filter, map, first, tap, mergeMap, catchError } from 'rxjs/operators';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { HttpClient } from '@angular/common/http';
import { IMemberAssociation } from 'src/app/common-page-components/stores/entities-store/member-association-store';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { MemberIndividualAssociationStore } from '../../../common-page-components/stores/entities-store/member-association-store';
import { CountryDependencyEntityStore } from '../../../common-page-components/stores/entities-store/country-dependency-entity-store';
import { ContinentalIndividualAssociationStore } from 'src/app/common-page-components/stores/entities-store/continental-individual-association-store';
import { RegionCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';
import { environment } from '@environments/environment';



/**
 * Instnace of members tabs.
 *
 * @export
 * @class BootstrapMembersTabsComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-bootstrap-members-tabs',
  templateUrl: './bootstrap-members-tabs.component.html',
  styleUrls: ['./bootstrap-members-tabs.component.scss']
})
export class BootstrapMembersTabsComponent implements OnInit {
  member: any;

  /**
   * Routes to bind to and make a substitution in the panel
   *
   * @type {Array<IThirdNavCollapsibleElement>}
   * @memberof BootstrapMembersTabsComponent
   */
  routes: Array<IThirdNavCollapsibleElement> = [
    { name: "Information", route: "noc/fedname", mustBeFullCheck:true },
    { name: "Events", route: "noc/fedname/events" },
    { name: "Athletes", route: "noc/fedname/athletes" },
    { name: "News", route: "noc/fedname/news" }
  ];

  /**
   * Members store for get data of panel
   *
   * @memberof BootstrapMembersTabsComponent
   */
  membersStore: MemberIndividualAssociationStore | ContinentalIndividualAssociationStore = new MemberIndividualAssociationStore(this.http, this.injector) as any;

  /**
   * Map between pages and their specific title, pretitle, and image.
   *
   * @memberof BootstrapMembersTabsComponent
   */
  mapRoutesWithTabs = {
    'default': {
      'image': '../../../../../modules/custom/wa_angular/app/assets/images/members-background-img.jpg',
      'pretitle': 'Members',
      'title': 'Archery federations'
    },
    'members_athletes': {
      'image': '../../../../../modules/custom/wa_angular/app/assets/images/members-background-img.jpg',
      'pretitle': 'Members',
      'title': 'Athletes'
    },
    'members_events': {
      'image': '../../../../../modules/custom/wa_angular/app/assets/images/members-background-img.jpg',
      'pretitle': 'Members',
      'title': 'Events'
    }
  };

  /**
   * Banner properties.
   *
   * @memberof BootstrapMembersTabsComponent
   */
  bannerProperties = this.mapRoutesWithTabs.default;

  /**
   *
   * News of association and member
   * @type {Array<INews>}
   * @memberof BootstrapMembersInformationComponent
   */
  news: Array<INews> = [];

  constructor(
    router: Router,
    private injector: Injector,
    private http: HttpClient,
    public member_router_interceptor: MembersRouterInterceptorService) {
    let isContinental;
    const tmpParams = { noc: undefined, fedname: '', urlSegments: {} };
    router.events.pipe(
      filter(a => a instanceof ActivationEnd),
      tap((a: ActivationEnd) => Object.assign(tmpParams.urlSegments, a.snapshot['_urlSegment'])),
      map((a: ActivationEnd) => a.snapshot.params),
      tap(a => Object.assign(tmpParams, a)),
      mergeMap(a => new RegionCombo('', '', http, new BehaviorSubject({})).requestData({}, false).pipe(map(a => a.items))),
      mergeMap(countries => {
        // Check if there's a country code or a continent for bind property to the store.
        if (isNaN(parseInt(tmpParams.noc, 10)) === false) {
          this.membersStore = new ContinentalIndividualAssociationStore(http, injector);

          return this.membersStore.requestData({ Continent: tmpParams.noc }, false).pipe(tap(a => tmpParams.noc = a.items[0].MaCode))
            .pipe(
              mergeMap(a => {
                this.member_router_interceptor.memberNewsStore.member_id =  a.items[0].CaId;

                // tslint:disable-next-line:max-line-length
                return of(a);
              })
            );
        } else {
          if (countries.findIndex(value => value.CaCode.toLowerCase() === tmpParams.noc.toLowerCase()) > -1) {

            this.membersStore = new ContinentalIndividualAssociationStore(http, injector);
            const caId = countries.find(value => value.CaCode.toLowerCase() === tmpParams.noc.toLowerCase()).CaId;
            this.member_router_interceptor.memberNewsStore.member_id = caId;
            // tslint:disable-next-line:max-line-length
            return this.membersStore.requestData({ Continent: caId }, false)
          } else {
            this.membersStore = new MemberIndividualAssociationStore(http, injector);
            this.member_router_interceptor.memberNewsStore.member_id = tmpParams.noc;
            return this.membersStore.requestData({ Noc: tmpParams.noc }, false)
          }

        }
      }),
      first(),
      mergeMap(a => {
        return new CountryDependencyEntityStore(http, injector).requestData({}, false).pipe(
          tap(value => {
            if (value.items.findIndex(country => country.NOC.toLowerCase() === tmpParams.noc.toLowerCase()) > -1) {
              isContinental = false;
            } else {
              isContinental = true;
            }
          }), map(value => a));
      }),
      mergeMap(a => {
        return this.member_router_interceptor.memberNewsStore.getRequest({}, false).pipe(
          // Catch error if any.
          catchError((err) => of(a)),
          // Send normal parameters for allow flow to continue.
          map(value => a)
        )
      })
    )
      .subscribe(next => {
        // Set member value
        this.member = next.items;
        // Set route for specific federation.
        this.routes = this.routes.map(value => {
          return {
            mustBeFullCheck: value.mustBeFullCheck,
            name: value.name,
            route: value.route.replace('noc', tmpParams.noc).replace('fedname', tmpParams.fedname)
          }
        });
        // Change tab names and images when user enters directly to a page.
        const segments = tmpParams.urlSegments['segments'].map(element => {
          return element.path;
        });
        const path = segments.join('/');
        if(isContinental){
          const continent = tmpParams.fedname[0].toUpperCase() + tmpParams.fedname.substring(1);
          this.routes.push({
            name: 'Ranking',
            route: `ranking/continental-ranking?continent=${continent}`,
            external:true,
          })
        }
        this.setTabsAttributesByCurrentRoute(path, isContinental);
        this.news = Array.from(this.member_router_interceptor.memberNewsStore.data) as any;
      });
  }

  /**
   * Method for easy access to data
   *
   * @readonly
   * @type {Observable<IMemberAssociation>}
   * @memberof BootstrapMembersTabsComponent
   */
  get data(): any {
    return this.membersStore.observableData;
  }


  /**
   * Given a url set the correct banner properties (image, title, pretitle).
   *
   * @param {string} url
   *   Url.
   *
   * @memberof BootstrapMembersTabsComponent
   */
  setTabsAttributesByCurrentRoute(url: string, isContinental: boolean) {
    if (isContinental) {
      // Delete events.
      this.routes.splice(1, 1);
      // Delete athletes.
      this.routes.splice(1, 1);
    }
    const hasNews = this.member_router_interceptor.memberNewsStore.data && this.member_router_interceptor.memberNewsStore.data.length > 0;
    if(!hasNews){
      const index = this.routes.findIndex((route) => route.name === 'News');
      this.routes.splice(index, 1);
    }
    if (url.match(/member\/[a-zA-Z-]+\/[a-zA-Z-]+\/events/)) {
      this.bannerProperties = this.mapRoutesWithTabs.members_events;
    }
    else if (url.match(/member\/[a-zA-Z-]+\/[a-zA-Z-]+\/athletes/)) {
      this.bannerProperties = this.mapRoutesWithTabs.members_athletes;
    }
    else {
      this.bannerProperties = this.mapRoutesWithTabs.default;
    }
  }

  ngOnInit() {
  }

  /**
   * Function to provide the propertly banner
   *
   * @param {IMemberAssociation} member
   * @returns
   * @memberof BootstrapMembersTabsComponent
   */
  provideBanner(member: IMemberAssociation) {
    if ((member.HeaderImage as any) instanceof Array) {
      return this.bannerProperties.image;
    } else {
      if (member.HeaderImage == null || member.HeaderImage.URL == null
        || member.HeaderImage.URL === '' || member.HeaderImage.URL.length === 0) {
        return this.bannerProperties.image;
      } else {
        return member.HeaderImage.URL;
      }
    }
  }
}
